import React from 'react';

import DatePickerControlled from 'shared/ui/Date/DateRangePickerControlled/DatePickerControlled';
import {useServerMetricsRangePicker} from 'features/server/model/useServerMetricsRangePicker';

import styles from './ServerMetricsRangePicker.module.scss';

interface IServerMetricsRangePickerProps {
    from: number,
    to: number,
    retentionDays: number,
    tzString?: string | null,
    // eslint-disable-next-line no-unused-vars
    onChange: (from: number, to: number) => void,
}

const DATE_TIME_FORMAT = 'dd.MM.yyyy HH:mm';

const ServerMetricsRangePicker: React.FC<IServerMetricsRangePickerProps> = ({
    from,
    to,
    retentionDays,
    tzString,
    onChange,
}) => {
    const {control, error, disabledDate, handleFromChange, handleToChange} = useServerMetricsRangePicker(
        from,
        to,
        retentionDays,
        tzString,
        onChange,
    );

    return (
        <div className={styles.container}>
            <div className={styles.row}>
                <DatePickerControlled
                    control={control}
                    name="fromValue"
                    format={DATE_TIME_FORMAT}
                    disabledDate={disabledDate}
                    cleanable={false}
                    onChange={handleFromChange}
                />
                <span className={styles.separator}>—</span>
                <DatePickerControlled
                    control={control}
                    name="toValue"
                    format={DATE_TIME_FORMAT}
                    disabledDate={disabledDate}
                    cleanable={false}
                    onChange={handleToChange}
                />
            </div>
            {error && <span className={styles.error}>{error}</span>}
        </div>
    );
};

export default ServerMetricsRangePicker;
